module.exports = __webpack_public_path__ + "img/29.be153dfd.png";